module.exports = __webpack_public_path__ + "static/media/suigun.04808493.png";